import { defineEvent } from '../types/event';
export var SIZE_GUIDE_LINK_CLICK = defineEvent({
    platforms: [
        {
            name: 'Optimizely',
            alias: 'Clicks_On_Size_Guide_Link'
        }
    ]
});
